// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] + "." + {"265":"d338ff9f","297":"4acb52dd","643":"b9f3b6e5"}[chunkId] + ".chunk.js";
};